import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-terms-long-pdf',
  templateUrl: './termsLongPdf.component.html',
  styleUrls: ['./termsLongPdf.component.css']
})
export class TermsLongPdfComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}
